import { ILabel } from 'Types/ILabel'

export function setLabel(array: Array<any>, label: string) {
  var temp: ILabel[] = []
  array.forEach((el: any) => temp.push({ value: el.id, label: el[label] }))
  return temp
}
